import { useNavigate } from '@tanstack/react-router'
import { ArrowRightIcon, LockIcon, Trash2Icon } from 'lucide-react'
import { type ButtonHTMLAttributes, type PropsWithChildren } from 'react'

import { Button } from '@/components/button/button'
import { Label } from '@/components/label/label'

import { cn } from '@/lib/utils'

export interface PrivacyAndSecurityProps {
  isSuperAdmin: boolean
}

export const PrivacyAndSecurity = ({ isSuperAdmin }: PrivacyAndSecurityProps) => {
  const navigate = useNavigate()

  const handleClickChangePasswordButton = () => {
    void navigate({ to: '/change-password' })
  }

  const handleClickDeleteAccountButton = () => {
    void navigate({ to: '/delete-account' })
  }

  return (
    <div>
      <Label>Privacy & Security</Label>
      <div className={cn('mt-4', 'space-y-4')}>
        <ItemButton onClick={handleClickChangePasswordButton}>
          <LockIcon size={20} />
          Change Password
        </ItemButton>
        {isSuperAdmin && (
          <ItemButton onClick={handleClickDeleteAccountButton}>
            <Trash2Icon size={20} />
            Delete Account
          </ItemButton>
        )}
      </div>
    </div>
  )
}

const ItemButton = ({ children, ...restProps }: PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>>) => {
  return (
    <Button
      type="button"
      variant="outline"
      className={cn('flex items-center gap-x-2', 'w-full', 'rounded-md border border-border')}
      {...restProps}
    >
      {children}
      <ArrowRightIcon size={20} className={cn('ml-auto')} />
    </Button>
  )
}
